"use client";

import React from "react";
import HeaderSection from "../../layout/HeaderSection";
import TransformationSteps from "./components/TransformationSteps";
import RelationshipsSection from "./components/RelationshipsSection";
import Footer from "../../layout/Footer";

/**
 * Green Route Page Component
 * Main component for the green transformation roadmap page
 */
const GreenRoadmapPage: React.FC = () => {
  return (
    <div className="min-h-screen ">
      {/* Header Section */}
      <HeaderSection
        title="Lộ trình Xanh"
        subtitle="Kiến tạo Xanh toà sáng tâm hồn Việt"
        backgroundImage="/header_90ad.png"
        ariaLabel="Green Route page header"
        overlayOpacity="medium"
      />

      {/* Transformation Steps Section */}
      <TransformationSteps />

      {/* Relationships Section */}
      <RelationshipsSection />

      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default GreenRoadmapPage;
